export default "__VITE_ASSET__97e414c7__"